import React, { useCallback, useContext, useEffect, useState } from "react";

import { Button, Divider, MenuItem } from "@blueprintjs/core";
import { ItemRenderer, Select } from "@blueprintjs/select";

import "components/Navbar/SecondaryNavbar.scss";

import { capitalize } from "lodash";

import { Company } from "types";
import CompanySelect from "components/CompanySelect";
import { useCompanies } from "hooks/useCompanies";
import { SelectedCompanyContext } from "utils/context";
import { useSearchParams } from "react-router-dom";
import { ParseToaster } from "utils/toasters";
import { companyKey } from "utils/utils";

const viewItems = ["Policies"];

const ViewSelect = Select.ofType<string>();

const renderView: ItemRenderer<string> = (view, { handleClick, modifiers }) => {
    if (!modifiers.matchesPredicate) {
        return null;
    }

    return <MenuItem active={modifiers.active} key={view} onClick={handleClick} text={view} />;
};

type Props = {
    page: string;
    actions?: Array<JSX.Element>;
};

export default function PolicyMenu({ page, actions }: Props) {
    const [pageView, setPageView] = useState(capitalize(page));
    const [selectedCompany, setSelectedCompany] = useContext(SelectedCompanyContext);
    const [companies, { loading, error }] = useCompanies();
    const [searchParams, setSearchParams] = useSearchParams();

    const onCompanySelect = useCallback(
        (c: Company) => {
            setSelectedCompany(c);

            setSearchParams({
                [companyKey]: btoa(c.id)
            });
        },
        [setSearchParams, setSelectedCompany]
    );

    useEffect(() => {
        if (searchParams) {
            const encoded = searchParams.get(companyKey);

            if (encoded) {
                try {
                    const company = atob(encoded);
                    setSelectedCompany(companies.find((c) => company === c.id));
                } catch (e) {
                    ParseToaster.show({
                        message: `Unexprected error encoding URL.`,
                        intent: "danger"
                    });
                }
            }
        }
    }, [companies, searchParams, setSelectedCompany]);

    return (
        <div className="secondary-navbar">
            <div className="left-group">
                <CompanySelect
                    companies={companies}
                    loading={loading}
                    error={error}
                    selectedCompany={selectedCompany}
                    onCompanySelect={onCompanySelect}
                />
                <Divider />
                <ViewSelect
                    disabled={!selectedCompany}
                    filterable={false}
                    itemRenderer={renderView}
                    items={viewItems}
                    activeItem={pageView}
                    onItemSelect={(v) => {
                        setPageView(v);
                        // history.push(
                        //     `/policies/${selectedCompany ? selectedCompany.id + "/" : ""}${v
                        //         .toLowerCase()
                        //         .replace(/\s+/g, "")}`
                        // );
                    }}
                    popoverProps={{ minimal: true }}
                >
                    <Button disabled={!selectedCompany} icon="eye-open" rightIcon="caret-down" text={pageView} />
                </ViewSelect>
            </div>
            {actions && selectedCompany && <div className="right-group">{actions}</div>}
        </div>
    );
}
